export const DataDict = {
// quote: {title: DataDictInfo, contractno: DataDictInfo}
// customer: {address: DataDictInfo, customerno: DataDictInfo}
};
